<template>
  <div v-show="show" class="topicPush-container">
      <div class="bg"></div>
      <div class="topicPush-edit">
        <div class="title">推智策</div>
        <div class="input">
          <div class="row">
            <p>标题：</p>
            <input v-model="title" maxlength="100" type="text" placeholder="请输入标题">
            <div class="num">{{title.length}}/100</div>
          </div>
          <div class="row">
            <p>简介：</p>
            <textarea v-model="info" maxlength="200" placeholder="请输入简介"></textarea>
            <div class="num">{{info.length}}/200</div>
          </div>
        </div>
        <div class="btns">
          <div @click="save" class="btn g">推送</div>
          <div @click="close" class="btn">取消</div>
        </div>
      </div>
  </div>
</template>

<script>
import {apis} from '@common/config'
import common from '@common/common'

export default {
  name: 'topicPush',
  data() {
    return {
      show: true,
      id: '',
      title: '',
      info: '',
      r: null
    }
  },
  methods: {
    open(c, r) {
      this.id = c.id
      this.title = c.title || ''
      this.info = ''
      this.r = r
      this.show = true
    },
    close() {
      this.show = false
      this.r(false)
    },
    save() {
      if(!this.title || !this.title.trim()){
        this.$toast('请输入标题')
        return
      }

      const info = {
        topic_id: this.id,
        title: this.title,
        description: this.info
      }

      common.myFetch(apis.newTopicPush, info, 'post').then(res => {
        if(res){
          this.$toast(res)
          this.show = false
          this.r(true)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../../assets/css/global.less';

  .topicPush-container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    z-index: 9999;

    .bg {
        position: absolute;
        z-index: -1;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(50, 59, 75, 0.3);
        backdrop-filter: blur(1.6px);
    }

    .topicPush-edit {
      width: 418px;
      background: #F9F9F9;
      border-radius: 4px;
      padding: 30px;
      box-sizing: border-box;

      .title {
        font-weight: bold;
        font-size: 16px;
        color: #050F0F;
        line-height: 18px;
        margin-bottom: 26px;
      }

      .input {
        display: flex;
        flex-direction: column;

        .row {
          position: relative;
          display: flex;
          flex-direction: column;
          margin-bottom: 20px;
          width: 100%;

          &:nth-last-of-type(1) {
            margin-bottom: 26px;
          }

          p {
            font-weight: bold;
            font-size: 14px;
            color: #050F0F;
            line-height: 20px;
            margin-bottom: 10px;
          }

          input {
            width: 100%;
            height: 32px;
            background: rgba(185,195,195,0.2);
            border-radius: 2px;
            outline: none;
            border: none;
            padding: 0 60px 0 20px;
            box-sizing: border-box;
          }

          textarea {
            width: 100%;
            height: 160px;
            background: rgba(185,195,195,0.2);
            border-radius: 2px;
            resize: none;
            outline: none;
            border: none;
            padding: 10px 20px;
            box-sizing: border-box;

            &::placeholder {
              color: #B9C3C3;
            }
          }

          .num {
            position: absolute;
            right: 10px;
            bottom: 10px;
            font-weight: 500;
            font-size: 12px;
            line-height: 17px;
            color: #829191;
          }
        }
      }

      .btns {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;

        .btn {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 120px;
          height: 32px;
          background: #B9C3C3;
          border-radius: 4px;
          font-weight: bold;
          font-size: 14px;
          color: #FFFFFF;
          user-select: none;
          cursor: pointer;

          &.g {
            background: #41B48C;
            margin-right: 20px;
          }
        }
      }
    }
}
</style>
